import { createAction } from "@ngrx/store";

export const show = createAction("[Navbar] show");
export const hide = createAction("[Navbar] hide");
export const toggle = createAction("[Navbar] toggle");
